import React from 'react';
import { Button } from 'react-admin';
import PropTypes from 'prop-types';
import { Grid, Typography } from '@material-ui/core/';
import { makeStyles } from '@material-ui/core/styles';
import classNames from 'classnames';

const useStyles = makeStyles({
  gridContainer: {
    padding: '16px'
  },
  gridContainerWithButtons: {
    padding: '16px 0'
  },
  buttonGridContainer: {
    minHeight: '40px',
    margin: '8px 0'
  },
  buttonGridContainerWithoutTitle: {
    marginTop: '3px',
    marginBottom: '13px'
  },
  title: {
    flex: 1,
    padding: '20px 0 0 0'
  },
  button: {
    border: '1px solid #E0E0E0',
    background: '#FFFFFF',
    alignSelf: 'center',
    marginLeft: '10px'
  },
  emptyText: {
    color: '#424242',
    fontSize: '14px',
    fontWeight: '400',
    display: 'inline-block',
    fontFamily: '"Segoe UI",Arial,sans-serif'
  }
});

/**
 * Component to use with the List
 * 2 use cases :
 *  - In subpages, like userphones with a top bar with create button
 *  - In list pages, like funds with only a text
 *
 * <List
 *  empty={<Empty />}
 * >
 *  ...
 * </List>
 *
 * @param {*} props
 */
const Empty = props => {
  const { classes: classesOverride, emptyText, buttons, title } = props;
  const classes = useStyles({ classes: classesOverride });

  const buttonsToShow = buttons.filter(button => !button.hide);

  return (
    <Grid
      container
      justifyContent="space-between"
      direction="column"
      data-testid={'container'}
      classes={{
        container: classNames(
          classes.gridContainer,
          buttonsToShow.length > 0 ? classes.gridContainerWithButtons : ''
        )
      }}
    >
      {buttonsToShow.length > 0 && (
        <ButtonList buttons={buttonsToShow} classes={classes} title={title} />
      )}
      <Grid item>
        <span data-testid="empty-text" className={classes.emptyText}>
          {emptyText}
        </span>
      </Grid>
    </Grid>
  );
};

const ButtonList = ({ buttons, classes, title }) => {
  return (
    <Grid
      item
      container
      direction="row"
      alignItems="center"
      data-testid="container-buttons"
      classes={{
        container: classNames(
          classes.buttonGridContainer,
          !title ? classes.buttonGridContainerWithoutTitle : ''
        )
      }}
    >
      <Typography component="h5" variant="h5" classes={{ h5: classes.title }}>
        {title}
      </Typography>
      {buttons.map((button, index) => {
        return React.isValidElement(button) ? (
          button
        ) : (
          <Button
            key={index}
            onClick={button.onClick}
            label={button.label}
            variant="outlined"
            color="primary"
            className={classes.button}
          />
        );
      })}
    </Grid>
  );
};

Empty.propTypes = {
  emptyText: PropTypes.string, // Text when nothing should be displayed
  buttons: PropTypes.array,
  title: PropTypes.string
};

Empty.defaultProps = {
  emptyText: 'No results found',
  buttons: []
};

export default Empty;
